const assetsConfig = [
  { field: "id", label: "ID", sortable: false, is_visible: true },
  { field: "asset_number", label: "Номер актива", sortable: true, is_visible: true },
  { field: "name", label: "Название актива", sortable: false, is_visible: true },
  { field: "sku", label: "Артикул", sortable: true, is_visible: true },
  { field: "inventory_number", label: "Инвентарный номер", sortable: true, is_visible: true },
  { field: "status", label: "Статус", sortable: true, is_visible: true },
  { field: "rental_point_name", label: "Пункт проката", sortable: true, is_visible: true },
  { field: "type", label: "Тип", sortable: true, is_visible: true },
  { field: "category", label: "Категория", sortable: true, is_visible: true },
  { field: "deposit", label: "Депозит", sortable: true, is_visible: true },
  { field: "purchase_price", label: "Цена покупки", sortable: true, is_visible: true },
  { field: "purchase_date", label: "Дата покупки", sortable: true, is_visible: true },
  { field: "total_revenue", label: "Общий доход", sortable: true, is_visible: true },
  { field: "rental_count", label: "Количество аренд", sortable: true, is_visible: true },
  { field: "last_rental_date", label: "Дата последней аренды", sortable: true, is_visible: true },
  { field: "profitability_date", label: "Дата окупаемости", sortable: true, is_visible: true },
  { field: "maintenance_date", label: "Дата обслуживания", sortable: true, is_visible: true },
  { field: "images", label: "Изображения", sortable: false, is_visible: true },
  { field: "value", label: "Стоимость", sortable: true, is_visible: true },
  { field: "meta_data", label: "Дополнительные данные", sortable: false, is_visible: true },
  { field: "created_at", label: "Дата создания", sortable: true, is_visible: true },
  { field: "updated_at", label: "Дата обновления", sortable: true, is_visible: true },
];

export default assetsConfig;
